import {
	PATH_REPORT_MILEAGE_SUMMARY,
	PATH_REPORT_CAR_WASH_GEO_ZONE_VISITS,
	PATH_REPORT_DEVICE_PLANNING_EXECUTION,
	PATH_REPORT_FUEL_CONSUMPTION_BY_DEVICE,
	PATH_REPORT_FUEL_CONSUMPTION_BY_ROUTE,
	PATH_REPORT_GROUP_ACTIVE_SESSIONS,
	PATH_REPORT_GROUP_MILEAGE,
	PATH_REPORT_RECEIVED,
	PATH_REPORT_SCHEDULE_EXECUTION_BY_ROUTES,
	PATH_REPORT_TRACKER_OUTAGES,
	PATH_REPORT_VOYAGE_POINT_AVERAGES,
	PATH_REPORT_VOYAGE_POINT_DATA
} from '@constants/navigate'
import {IReportNavigateItem} from '@containers/reports/readyReports/navigateReadyReports/types'

export const READY_REPORTS_NAVIGATE: IReportNavigateItem[] = [
	{
		label: 'reportLabels.reportReceived',
		path: PATH_REPORT_RECEIVED,
	},
	{
		label: 'reportLabels.reportScheduleExecutionByRoutes',
		path: PATH_REPORT_SCHEDULE_EXECUTION_BY_ROUTES,
	},
	{
		label: 'reportLabels.reportDevicePlanningExecution',
		path: PATH_REPORT_DEVICE_PLANNING_EXECUTION,
	},
	{
		label: 'reportLabels.reportVoyagePointData',
		path: PATH_REPORT_VOYAGE_POINT_DATA,
	},
	{
		label: 'reportLabels.reportVoyagePointAverages',
		path: PATH_REPORT_VOYAGE_POINT_AVERAGES,
	},
	{
		label: 'reportLabels.reportGroupMileage',
		path: PATH_REPORT_GROUP_MILEAGE,
	},
	{
		label: 'reportLabels.reportFuelConsumptionByRoute',
		path: PATH_REPORT_FUEL_CONSUMPTION_BY_ROUTE,
	},
	{
		label: 'reportLabels.reportFuelConsumptionByDevice',
		path: PATH_REPORT_FUEL_CONSUMPTION_BY_DEVICE,
	},
	{
		label: 'reportLabels.reportGroupActiveSession',
		path: PATH_REPORT_GROUP_ACTIVE_SESSIONS,
	},
	{
		label: 'reportLabels.reportCarWashGeoZoneVisits',
		path: PATH_REPORT_CAR_WASH_GEO_ZONE_VISITS,
	},
	{
		label: 'reportLabels.reportMileageSummary',
		path: PATH_REPORT_MILEAGE_SUMMARY,
	},
	{
		label: 'reportLabels.reportTrackerOutages',
		path: PATH_REPORT_TRACKER_OUTAGES,
	},
]